import type { FirebaseOptions } from "firebase/app";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseAppConfig: FirebaseOptions = {
    apiKey: import.meta.env?.REACT_APP_FIREBASE_KEY,
    authDomain: import.meta.env?.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env?.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env?.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env?.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env?.REACT_APP_FIREBASE_APP_ID,
    measurementId: import.meta.env?.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const extendedConfig = {
    mapsApiKey: import.meta.env?.REACT_APP_MAPS_PLATFORM_API_KEY,
    conciergeServiceHourAssetUrl: import.meta.env
        ?.REACT_APP_STATIC_ASSET_URL_CONCIERGE_SERVICE_HOURS,
};

console.log("firebaseAppConfig", firebaseAppConfig);
console.log("extendedConfig", extendedConfig);

const apiServerBaseUrl =
    import.meta.env?.REACT_APP_API_SERVER_BASE_URL ?? "https://api.albertineapp.com";
console.log("apiServerBaseUrl", apiServerBaseUrl);

const defaultMiniAppsHosting: Record<ImportMetaEnv["ALBERTINE_ENV"], string> = {
    localhost: "http://localhost:6789",
    dev: "https://embed.dev.albertineapp.com",
    staging: "https://embed.staging.albertineapp.com",
    prod: "https://embed.albertineapp.com",
};

const miniAppsHosting =
    import.meta.env?.REACT_APP_MINI_APPS_HOSTING ||
    defaultMiniAppsHosting[import.meta.env?.ALBERTINE_ENV ?? "prod"];

export const keycloakConfig = {
    authority: import.meta.env?.REACT_APP_KEYCLOAK_AUTHORITY as string,
    clientId: import.meta.env?.REACT_APP_KEYCLOAK_CLIENT_ID as string,
    // Prefer the configured redirect URI: it is the live host, registered in
    // Keycloak for dev/staging/prod, so those environments are unchanged. Preview
    // builds blank REACT_APP_KEYCLOAK_REDIRECT_URI (see firebase/deploy-preview.sh)
    // so login falls back to window.location.origin — the *.web.app URL the
    // preview is served from — and returns there instead of the baked live host.
    // Mirrors post_logout_redirect_uri, which already uses window.location.origin.
    redirectUri:
        (import.meta.env?.REACT_APP_KEYCLOAK_REDIRECT_URI as string | undefined) ||
        (typeof window !== "undefined" ? window.location.origin : ""),
};

export default {
    ...firebaseAppConfig,
    ...extendedConfig,
    apiServerBaseUrl,
    miniAppsHosting,
};
